import { computed, isRef, ref } from 'vue';

export function useIntRef(value) {
    if (!isRef(value)) {
        value = ref(value);
    }

    const view = computed({
        get() {
            if (value.value === null) {
                return value.value;
            }
            if (isNaN(value.value)) {
                return value.value;
            }
            const view = Number.parseInt(value.value);
            return view.toString();
        },
        set(newValue) {
            if (newValue === null) {
                value.value = null;
                return;
            }

            const stringVal = newValue;
            newValue = Number.parseInt(newValue);
            if (isNaN(stringVal)) {
                console.warn('invalid int string');
                value.value = stringVal;
                return;
            }

            value.value = newValue;
        },
    });

    return {
        value,
        view,
    };
}
